var render = function render(){var _vm=this,_c=_vm._self._c;return _c('design-2021-apprentice-data-table',{attrs:{"nosearch":"","fields":_vm.fields,"items":_vm.logItems},on:{"row-clicked":_vm.rowClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }